import { SVGProps } from 'react';

export type DatepickerIconProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

export const DatepickerIcon = ({ color = '#646464', ...props }: DatepickerIconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.83333 9.16675H7.5V10.8334H5.83333V9.16675ZM17.5 5.00008V16.6667C17.5 17.5834 16.75 18.3334 15.8333 18.3334H4.16667C3.24167 18.3334 2.5 17.5834 2.5 16.6667L2.50833 5.00008C2.50833 4.08341 3.24167 3.33341 4.16667 3.33341H5V1.66675H6.66667V3.33341H13.3333V1.66675H15V3.33341H15.8333C16.75 3.33341 17.5 4.08341 17.5 5.00008ZM4.16667 6.66675H15.8333V5.00008H4.16667V6.66675ZM15.8333 16.6667V8.33342H4.16667V16.6667H15.8333ZM12.5 10.8334H14.1667V9.16675H12.5V10.8334ZM9.16667 10.8334H10.8333V9.16675H9.16667V10.8334Z"
      fill={color}
    />
  </svg>
);
